import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../actions';
import config from '../../config';

function customizeMessageList(Message, Timestamp) {
    return class extends Component {
        loadMore(showMore, TimestampComponent) {
            return showMore ? (
                <TimestampComponent
                    className="get-more"
                    key="pull-up"
                    onClick={() => {
                        this.props.getHistoryMsgs({ scene: 'p2p', to: this.props.to });
                    }}
                >
                    点击加载更多
                </TimestampComponent>
            ) : (
                <TimestampComponent key="no-more">已无更多记录</TimestampComponent>
            );
        }

        render() {
            const { type, isRobot, isHistory = false } = this.props;
            const messages = [];
            for (let i = 0; i < this.props.messageCount; i++) {
                messages.push(
                    <Message key={i} index={i} type={type} isRobot={isRobot} isHistory={isHistory} />
                );
            }

            if (messages.length > 0) {
                let showMore = false;
                if (!this.props.isLocalSession) {
                    showMore = !this.props.noMoreHistoryMsgs;
                }
                return [this.loadMore(showMore, Timestamp), ...messages];
            } else {
                return null;
            }
        }
    };
}

function MessageList(Message, Timestamp) {
    const connected = connect(
        state => {
            const { imStore, isLocalSession } = state[config.reduxStoreName];
            return {
                messageCount: imStore.currSessionMsgs.length || 0,
                noMoreHistoryMsgs: imStore.noMoreHistoryMsgs,
                isLocalSession,
            };
        },
        { getHistoryMsgs: actions.getHistoryMsgs }
    )(customizeMessageList(Message, Timestamp));
    connected.displayName = `Custom(${getDisplayName(Message)})List`;
    return connected;
}

export default MessageList;

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
